// src/Redux/thunks/assistantThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAssistant } from "../../../api/axios";
import ENDPOINTS from "../../../api/endpoints";

/**
 * Send a chat message to the assistant via API-Gateway
 * payload = { text: string, context: object }
 * backend expects: { message, context }
 */
export const sendAssistantMessage = createAsyncThunk(
    "assistant/sendAssistantMessage",
    async ({ text, context }, { rejectWithValue }) => {
        try {
            const { data } = await axiosAssistant.post(ENDPOINTS.ASSISTANT.CHAT, {
                message: text,
                context,
            });

            return {
                message: data?.message ?? "",
                links: Array.isArray(data?.links) ? data.links : [],
                action: data?.action ?? null,
                data: data?.data ?? {},
                ui: data?.ui ?? null,
                meta: data?.meta ?? null,
            };
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);

/** Optional: health ping if you need it in UI */
export const assistantHealth = createAsyncThunk(
    "assistant/health",
    async (_, { rejectWithValue }) => {
        try {
            const { data } = await axiosAssistant.get(ENDPOINTS.ASSISTANT.HEALTH);
            return data;
        } catch (err) {
            return rejectWithValue(err);
        }
    }
);
